import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages, { autoSplitFilterOptions } from '../messages';
import {
  DoNotAutoSplit,
  SplitOnLineItem,
  SplitOnQuantity,
  SplitOnCustomQty,
} from '../../../products/product-details/constants/auto-split-options';

const name = <FormattedMessage {...messages.autoSplitColumnHeader} />;

const columnDisplayMap = {
  [DoNotAutoSplit]: '',
  [SplitOnLineItem]: <FormattedMessage {...autoSplitFilterOptions.splitOnLineItem} />,
  [SplitOnQuantity]: <FormattedMessage {...autoSplitFilterOptions.splitOnQuantity} />,
};

export default {
  getMessageDescriptor: () => messages.autoSplitColumnHeader,
  name,
  render: (data) => {
    if (data.autoSplitOption === SplitOnCustomQty) {
      return (
        <FormattedMessage
          {...autoSplitFilterOptions.splitOnCustomQuantity}
          values={{
            customQty: data.autoSplitCustomQuantity,
          }}
        />
      );
    }
    return columnDisplayMap[data.autoSplitOption] || '';
  },
};
